// export const BASE_URL = 'https://midad-api.beetronix.net';
// export const BASE_URL = 'https://awtadalbarakeh-api.midadworld.com';
export const BASE_URL = 'https://api.mirta.coffee';
export const BYTE_RANGE_BASE_URL = BASE_URL + '/api/file-manager/stream';

export const INNER_VERSION = '1.18.1';
export const VERSION = '3.5.1';